import { render, staticRenderFns } from "./AbstractsTable.vue?vue&type=template&id=d4e5bdc2&scoped=true"
import script from "./AbstractsTable.vue?vue&type=script&lang=js"
export * from "./AbstractsTable.vue?vue&type=script&lang=js"
import style0 from "./AbstractsTable.vue?vue&type=style&index=0&id=d4e5bdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e5bdc2",
  null
  
)

export default component.exports